import { Icon } from "../../../../components/icon";
import CadastroAnalise from "../../../../assets/icons/cadastro-analise.svg";

export const StatusCadastro = ({type = 1}) => {
    return(
        <div className='conta-content'>
            <div className='conta-content-section'>
                <h2 className="conta-section-title">Seja bem vindo!</h2>

                {type == 0?
                <>
                    <span className="row" style={{gap:25, fontSize:'1.112rem',fontWeight:600,alignItems:"center", marginBottom:40,marginTop:40}}>
                        <div className="checkmark_container" >
                            <div className="checkmark">
                                <div class="checkmark_stem"></div>
                                <div class="checkmark_kick"></div> 
                            </div> 
                        </div>
                        Recebemos suas informações. Em breve nossos especialistas entrarão em contato
                    </span>
                    <div className="divider"/>
                    <p style={{ fontSize:'1.112rem',fontWeight:600}}>Status do processo da sua conta</p>
                    <div className="row" style={{backgroundColor:"#F9FBF9", borderRadius:4, width:"100%", padding:34, gap:20,alignItems:"center"}}>
                        <Icon icon={CadastroAnalise} size={35}/>
                        <div style={{display:"flex", flexDirection:"column", gap:1}}>
                            <span style={{fontSize:"0.889rem", fontWeight:"bold"}}>Cadastro em análise.</span>
                            <span style={{fontSize:"0.778rem"}}>Assim que esse processo for concluído, você será notificado por nossos especialistas.</span>
                        </div>
                    </div>
                </>
                :
                <>
                <span className="row" style={{gap:25, fontSize:'1.112rem',fontWeight:600,alignItems:"start", marginBottom:40,marginTop:40}}>
                        <div className="checkmark_container" >
                            <div className="checkmark">
                                <div class="checkmark_stem"></div>
                                <div class="checkmark_kick"></div> 
                            </div> 
                        </div>
                       <div style={{display:"flex", flexDirection:"column", gap:5}}>
                        <span>Sua conta foi aberta com sucesso!</span>
                        <span style={{fontSize:"0.889rem", fontWeight:300}}>Você já pode fazer sua primeira operação!</span>
                        <a className="btn-style" style={{borderRadius:4, width:"100%", marginTop:"10px"}} href="https://www.iamsimple.com.br/cobalt" target="_blank" rel="noopener noreferrer"> Acessar Plataforma  </a>
                       </div>
                </span>
                </>
                }
            </div>
        </div>
    )
}